import { render, staticRenderFns } from "./error-monitor-datatable.component.vue?vue&type=template&id=630d63b4&scoped=true&"
import script from "./error-monitor-datatable.component.vue?vue&type=script&lang=ts&"
export * from "./error-monitor-datatable.component.vue?vue&type=script&lang=ts&"
import style0 from "./error-monitor-datatable.component.vue?vue&type=style&index=0&id=630d63b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d63b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDataTable,VIcon})
